import Vue from 'vue'
import router from './router'
import './assets/pc.js';
import ElementUI from 'element-ui';
//样式文件需要单独引入
import 'element-ui/lib/theme-chalk/index.css';
import VueUeditorWrap from 'vue-ueditor-wrap';
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import * as echarts from 'echarts';
import serve from './api/api';
import api from './api/url'
import utils from './utils/utils'
import { getDictLabelById, getDictLabel} from "@/utils";
import App from './App.vue'
Vue.use(ElementUI);
Vue.component('vue-ueditor-wrap', VueUeditorWrap);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false
Vue.prototype.$api = serve
Vue.prototype.$url = api
Vue.prototype.$echarts = echarts
Vue.prototype.$getDictLabelById = getDictLabelById
Vue.prototype.$getDictLabel = getDictLabel



// 加载地区树数据
utils.loadRegionTree().then(() => {
}).catch(error => {
  console.error('地区树数据加载失败:', error);
});
// 加载主要产品分类数据
utils.loadMainProductTree().then(() => {
}).catch(error => {
  console.error('主要产品分类数据加载失败:', error);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
